import { Injectable } from '@angular/core';
import {
  SortOrder,
  GetAccountPagePaksResponsePayload,
  GetUnassignedPaksResponsePayload,
  BFFGetPaksWithAccountsResponsePayload,
  GetSharedPacksResponsePayload,
  GetRecentPaksResponsePayload,
  GetAccountPagePaksRequestPayload,
  GetUnassignedPagePaksRequestPayload,
  GetSharedPacksRequestPayload,
  BFFGetPaksWithAccountsRequestPayload,
} from '@cpak/adp-cpak-bff-service-models';
import { PaksTargetType, GetPaksSortType } from '@cpak/adp-cpak-quotes-service-models';
import { PaginationConfig } from '@cpak/consts';
import { Observable } from 'rxjs';
import { FetcherService } from '../fetcher/fetcher.service';

@Injectable({
  providedIn: 'root',
})
export class GetPaksService {
  constructor(private fetcher: FetcherService) {}
  private readonly defaultParams = {
    sort: GetPaksSortType.modifiedDate,
    sortOrder: SortOrder.desc,
    archived: false,
    offset: PaginationConfig.startPage,
    limit: PaginationConfig.limit,
  };

  public getPacksByAccountId(
    payload: GetAccountPagePaksRequestPayload
  ): Observable<GetAccountPagePaksResponsePayload | null> {
    if (!payload.target) {
      delete payload.target;
    }

    if (!payload.groupingType) {
      delete payload.groupingType;
    }

    return this.fetcher.get(`/api/pages/accounts/${payload.id}/paks`, { ...this.defaultParams, ...payload });
  }

  public getUnassignedPacks(
    payload: GetUnassignedPagePaksRequestPayload
  ): Observable<GetUnassignedPaksResponsePayload | null> {
    payload.target = PaksTargetType.quote;

    return this.fetcher.get(`/api/pages/accounts/unassignedPaks`, {
      ...this.defaultParams,
      ...payload,
    });
  }

  public getSharedPacks(payload: GetSharedPacksRequestPayload): Observable<GetSharedPacksResponsePayload | null> {
    if (!payload.target) {
      delete payload.target;
    }

    if (!payload.groupingType) {
      delete payload.groupingType;
    }

    return this.fetcher.get(`/api/pages/accounts/sharedPacks`, {
      ...this.defaultParams,
      ...payload,
    });
  }

  public getPacksWithAccounts(
    payload: BFFGetPaksWithAccountsRequestPayload
  ): Observable<BFFGetPaksWithAccountsResponsePayload | null> {
    const defaultPayload = {
      limit: this.defaultParams.limit,
      offset: this.defaultParams.offset,
      archived: this.defaultParams.archived,
    };

    if (!payload.target) {
      delete payload.target;
    }

    if (!payload.territoryIds?.length) {
      delete payload.territoryIds;
    }

    return this.fetcher.get(`/api/paksWithAccounts`, { ...defaultPayload, ...payload });
  }

  public getRecentPacks(countryIds: string, territoryIds: string[]): Observable<GetRecentPaksResponsePayload | null> {
    return this.fetcher.get('/api/paks/recent', { territoryIds, countryIds });
  }
}
